<app-spinner></app-spinner>
<!-- <router-outlet></router-outlet> -->
<div class="page-content  ">
    <div class="row">

        <div class="col-lg-12 col-md-12">

            <div class="ibox" style="background-color: white;">
                <!-- <div class="ibox-head">
                    <div class="ibox-title" style="font-size: 20px; font-weight: 500; color:  #000;

;">
                        User Management
                    </div>
                   
                    <div class="col-5 justify-content-end d-flex ">
                        <button *ngIf="!create_flag" class="btn hover-light d-flex align-items-center"
                            style="background-color: #226CE0; margin: 5px;" (click)="open_create()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                                fill="none">
                                <g clip-path="url(#clip0_582_3012)">
                                    <path
                                        d="M10.6667 14.5V13.1667C10.6667 12.4594 10.3858 11.7811 9.8857 11.281C9.3856 10.781 8.70732 10.5 8.00008 10.5H3.33341C2.62617 10.5 1.94789 10.781 1.4478 11.281C0.9477 11.7811 0.666748 12.4594 0.666748 13.1667V14.5M13.3334 5.83333V9.83333M15.3334 7.83333H11.3334M8.33341 5.16667C8.33341 6.63943 7.13951 7.83333 5.66675 7.83333C4.19399 7.83333 3.00008 6.63943 3.00008 5.16667C3.00008 3.69391 4.19399 2.5 5.66675 2.5C7.13951 2.5 8.33341 3.69391 8.33341 5.16667Z"
                                        stroke="#F5F5F5" stroke-width="1.6" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_582_3012">
                                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span class="p-1 text-white">Add New User</span>
                        </button>



                    </div>

                </div> -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h4> {{ translation.t('adminUserManagement', 'title') }}</h4>
                    <button class="btn dept  hover-light" *ngIf="!create_flag"
                        style="background-color: #226CE0;box-shadow: none;padding: 5px 8px; border-radius: 6px !important;"
                        (click)="open_create()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                            <g clip-path="url(#clip0_582_3012)">
                                <path
                                    d="M10.6667 14.5V13.1667C10.6667 12.4594 10.3858 11.7811 9.8857 11.281C9.3856 10.781 8.70732 10.5 8.00008 10.5H3.33341C2.62617 10.5 1.94789 10.781 1.4478 11.281C0.9477 11.7811 0.666748 12.4594 0.666748 13.1667V14.5M13.3334 5.83333V9.83333M15.3334 7.83333H11.3334M8.33341 5.16667C8.33341 6.63943 7.13951 7.83333 5.66675 7.83333C4.19399 7.83333 3.00008 6.63943 3.00008 5.16667C3.00008 3.69391 4.19399 2.5 5.66675 2.5C7.13951 2.5 8.33341 3.69391 8.33341 5.16667Z"
                                    stroke="#F5F5F5" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_582_3012">
                                    <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                                </clipPath>
                            </defs>
                        </svg> <span class="p-1 text-white">{{ translation.t('adminUserManagement', 'addNewUser') }}</span>
                    </button>
                </div>

                <div class="ibox-body">
                    <ul class="nav nav-tabs tabs-line">
                        <li class="nav-item">
                            <a class="nav-link" *ngIf="create_flag" data-toggle="tab"><i class="ti-settings"></i>
                                {{ translation.t('adminUserManagement', 'createEmployee') }}
                            </a>


                        </li>
                        <li class="nav-item">
                            <a class="nav-link" *ngIf="update_flag" data-toggle="tab"><i class="ti-tasks"></i>
                                {{ translation.t('adminUserManagement', 'updateEmployeeId') }}
                            </a>
                        </li>



                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" *ngIf="list_flag" id="tab-1">
                            <br>

                            <!-- <div class="row">
                                    <div class="col-4 text-end">
                                        <h6>
                                            Select Employee Active Status

                                        </h6>
                                    </div>
                                    <div class="col-4">
                                        <ng-select [items]="status" (change)="changeEmployee()" bindLabel="value" bindValue="code" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="emp_status" [selectableGroupAsModel]="false" [closeOnSelect]="true" name="field_name">
                                        </ng-select>

                                    </div>
                                </div>
                                <br> 
                             <div class="row">
                                <div class="col-11 text-end">


                                    <button style="margin: 5px;" (click)="open_create()" class="btn btn-success">Add
                                        New Employee</button>
                                </div>

                            </div>  -->
                            <div class="row">
                                <div class="col-12 text-left">
                                    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div style="font-weight: 400; font-size: 20px; color: #000;">{{ translation.t('adminUserManagement', 'allUsers') }}</div>
    <div class="input-group mb-3 search-input-wrapper" style="max-width: 250px;">
        <span class="input-group-text bg-white border-end-0">
            <img src="../../../../assets/img/cfc/services/Icon.svg" alt="icon"
                style="width: 16px; height: 16px;">
        </span>
        <input type="text" class="form-control"
            style="border-style: none; border: 1px solid gainsboro; outline: none;"
            [placeholder]="translation.t('adminUserManagement', 'searchUsers')" [(ngModel)]="searchText"
            (input)="applySearch()">
    </div>
</div>
                                    <!-- <div class="d-flex justify-content-between align-items-center mb-3">
                                        <div style="font-weight: 400; font-size: 20px; color: #000;">{{ translation.t('adminUserManagement', 'allUsers') }}</div>
                                        <div class="input-group mb-3" style="max-width: 250px;">
                                            <span class="input-group-text bg-white border-end-0">
                                                <img src="../../../../assets/img/cfc/services/Icon.svg" alt="icon"
                                                    style="width: 16px; height: 16px;">
                                            </span>
                                            <input type="text" class="form-control "
                                                style="border-style: none; border: 1px solid gainsboro; outline: none;"
                                                [placeholder]="translation.t('adminUserManagement', 'searchUsers')" [(ngModel)]="searchText"
                                                (input)="applySearch()">
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-bordered w-100 tableshadow">
                                    <thead class=" table table-light">
                                        <tr>
                                            <th>{{ translation.t('adminUserManagement', 'name') }}</th>
                                            <th>{{ translation.t('adminUserManagement', 'role') }}</th>
                                            <th>{{ translation.t('adminUserManagement', 'contact') }}</th>
                                            <th>{{ translation.t('adminUserManagement', 'viewMore') }}</th>
                                            <th>{{ translation.t('adminUserManagement', 'organization') }}</th>
                                            <th>{{ translation.t('adminUserManagement', 'status') }}</th>
                                            <th>{{ translation.t('adminUserManagement', 'actions') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let user of pagedUsers">
                                            <td>{{ user.emp_name }}</td>
                                            <td><span class="code">{{ user.role_cd }}</span></td>
                                            <td>{{user.emp_phone_no}}</td>
                                            <!-- <td>{{user.department}}</td> -->

                                            <td style="color: rgb(0, 26, 255); cursor: pointer;"
                                                (click)="openEmpDetailModal(user)">
                                                <span>{{ translation.t('adminUserManagement', 'viewMore') }}</span>
                                            </td>



                                            <td>{{user.org}}</td>

                                            <td><span class="ba"
                                                    style="background-color: #226CE0; color: white; padding: 3px 10px ; border-radius: 6px;">{{ translation.t('adminUserManagement', 'active') }}</span>
                                            </td>
                                            <td style="padding: 0px 30px !important;">
                                                <button class="me-1 edit" (click)="openUpdate(user)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17"
                                                        viewBox="0 0 17 17" fill="none">
                                                        <g clip-path="url(#clip0_582_5824)">
                                                            <path
                                                                d="M7.83325 3.16665H3.16659C2.81296 3.16665 2.47382 3.30713 2.22378 3.55718C1.97373 3.80723 1.83325 4.14637 1.83325 4.49999V13.8333C1.83325 14.1869 1.97373 14.5261 2.22378 14.7761C2.47382 15.0262 2.81296 15.1667 3.16659 15.1667H12.4999C12.8535 15.1667 13.1927 15.0262 13.4427 14.7761C13.6928 14.5261 13.8333 14.1869 13.8333 13.8333V9.16665M12.8333 2.16665C13.0985 1.90144 13.4582 1.75244 13.8333 1.75244C14.2083 1.75244 14.568 1.90144 14.8333 2.16665C15.0985 2.43187 15.2475 2.79158 15.2475 3.16665C15.2475 3.54173 15.0985 3.90144 14.8333 4.16665L8.49992 10.5L5.83325 11.1667L6.49992 8.49999L12.8333 2.16665Z"
                                                                stroke="#1E1E1E" stroke-width="1.6"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_582_5824">
                                                                <rect width="16" height="16" fill="white"
                                                                    transform="translate(0.5 0.5)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </button>
                           
                                                <!-- <button class="delete" (click)="openDelete(user)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                                        viewBox="0 0 23 23" fill="none">
                                                        <path d="M9.66675 14.25L9.66675 11.5" stroke="#F52525"
                                                            stroke-width="2" stroke-linecap="round" />
                                                        <path d="M13.3333 14.25L13.3333 11.5" stroke="#F52525"
                                                            stroke-width="2" stroke-linecap="round" />
                                                        <path
                                                            d="M3.25 6.91666H19.75V6.91666C19.0522 6.91666 18.7033 6.91666 18.4194 7.00278C17.7802 7.19668 17.28 7.69688 17.0861 8.33609C17 8.61998 17 8.96888 17 9.66666V14.8333C17 16.7189 17 17.6618 16.4142 18.2475C15.8284 18.8333 14.8856 18.8333 13 18.8333H10C8.11438 18.8333 7.17157 18.8333 6.58579 18.2475C6 17.6618 6 16.7189 6 14.8333V9.66666C6 8.96888 6 8.61998 5.91388 8.33609C5.71998 7.69688 5.21977 7.19668 4.58057 7.00278C4.29667 6.91666 3.94778 6.91666 3.25 6.91666V6.91666Z"
                                                            stroke="#F52525" stroke-width="1.5"
                                                            stroke-linecap="round" />
                                                        <path
                                                            d="M9.72906 3.58971C9.83351 3.49225 10.0637 3.40613 10.3839 3.34471C10.704 3.28329 11.0963 3.25 11.4999 3.25C11.9035 3.25 12.2958 3.28329 12.616 3.34471C12.9362 3.40613 13.1663 3.49225 13.2708 3.58971"
                                                            stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                                                    </svg>
                                                </button> -->
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <ng-template #empDetailModal let-modal>
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <div>
                                            <h3 class="modal-title">{{ translation.t('adminUserManagement', 'employeeDetails') }}</h3>
                                            <p class="text-muted mb-0">{{ translation.t('adminUserManagement', 'employeeDetailsSubtitle') }}</p>
                                        </div>
                                        <button type="button" class="btn-close" aria-label="Close"
                                            (click)="modal.dismiss()">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                                                viewBox="0 0 50 50" fill="none">
                                                <path
                                                    d="M17.6333 32.3646L32.3666 17.6354M17.6333 17.6354L32.3666 32.3646"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </button>
                                    </div>

                                    <div class="modal-body">
                                        <div class="row g-3 mb-3 mt-1">
                                            <div class="col-12 col-md-6">
                                                <label class="form-label">{{ translation.t('adminUserManagement', 'employeeName') }}</label>
                                                <div class="form-control bg-light">{{ selectedUser?.emp_name || '-' }}
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <label class="form-label">{{ translation.t('adminUserManagement', 'email') }}</label>
                                                <div class="form-control bg-light">{{ selectedUser?.emp_email || '-' }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row g-3 mb-3">
                                            <div class="col-12 col-md-6">
                                                <label class="form-label">{{ translation.t('adminUserManagement', 'phoneNumber') }}</label>
                                                <div class="form-control bg-light">{{ selectedUser?.emp_phone_no || '-'
                                                    }}</div>
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <label class="form-label">{{ translation.t('adminUserManagement', 'dob') }}</label>
                                                <div class="form-control bg-light">{{ selectedUser?.emp_dob |
                                                    date:'dd/MM/yyyy' }}</div>
                                            </div>
                                        </div>

                                        <div class="row g-3">
                                            <div class="col-12 col-md-6">
                                                <label class="form-label">{{ translation.t('adminUserManagement', 'department') }}</label>
                                                <div class="form-control bg-light">
                                                     <ul *ngFor="let ob of selectedUser['department']">
                                                        <li>{{ob['department_name']}}</li>
                                                     </ul> 
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <label class="form-label">{{ translation.t('adminUserManagement', 'organization') }}</label>
                                                <div class="form-control bg-light">{{ selectedUser?.org || '-' }}</div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </ng-template>


                            <div class="d-flex justify-content-end align-items-end mt-3 flex-wrap me-4"
                                style="margin: 10px;">
                                <span style="color: #6D6D6D; font-size: 14px;">
                                    {{ translation.t('adminUserManagement', 'showing') }} {{ pagedUsers.length }} {{ translation.t('adminUserManagement', 'of') }} {{ filteredUsers.length }} {{ translation.t('adminUserManagement', 'users') }}
                                </span>


                                <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
                                    <label class="me-1">Per page:</label>
                                    <select [(ngModel)]="pageSize" (change)="changePageSize()"
                                        class="form-select form-select-sm w-auto">
                                        <option *ngFor="let size of page_list" [value]="size">{{ size }}</option>
                                    </select>

                                    <button class="btn-sm fw-bold px-3 py-1 me-2" (click)="prevPage()"
                                        [disabled]="currentPage === 1">&lt;</button>

                                    <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

                                    <button class="btn-sm fw-bold px-3 py-1" (click)="nextPage()"
                                        [disabled]="currentPage === totalPages">&gt;</button>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade show active" *ngIf="create_flag" id="tab-2" style="margin-top: 50px;">
                            <div class="d-flex justify-content-end">
                                <button class="btn" style="background-color: #333; color: white;"
                                    (click)="open_list()"><span class="p-1">&larr;</span> {{ translation.t('adminUserManagement', 'backToList') }}</button>

                            </div>


                            <mat-horizontal-stepper [linear]="true" #matStepper>
                                <mat-step [stepControl]="first" completed="false">
                                    <ng-template matStepLabel>
                                        <span matTooltip="{{ translation.t('adminUserManagement', 'search') }}" class="step-label-tooltip">{{ translation.t('adminUserManagement', 'search') }}</span>
                                    </ng-template>
                                    <br>
                                    <br>

                                    <div class="row align-items-center mb-3">
                                        <div class="col-12 col-sm-5 mb-2 mb-sm-0 text-sm-end text-start">
                                            <h6 class="mb-0">
                                                {{ translation.t('adminUserManagement', 'enterMobile') }} <span class="text-danger">*</span>
                                            </h6>
                                        </div>

                                        <div class="col-12 col-sm-3">
                                            <input class="form-control" type="number" maxlength="10"
                                                oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                [(ngModel)]="joiningObj['credential']" />
                                        </div>
                                    </div>

                                    <!-- <input type="email" class="form-control" [(ngModel)]="joiningObj['credential']"> -->
                                    <!-- <input type="email"  placeholder="{{mainService.allLableShowObjHR[mainService.language_cd+'HR-Joining3']}}" class="form-control"  #ngInput1 (input)="onInput($event)" (ngModelChange)="checkAccount(ngInput1.value)" [(ngModel)]="joiningObj['credential']"> <br>
                                    

                                            <ng-container *ngIf="accNoLen==false; else elseTemplate"  style="color: red">
                                                <span style="color: red"> <i>Mobile No Must be in range of 10 digit </i>  </span>
                                             </ng-container>
                                                        <ng-template #elseTemplate  style="color: green">
                                                                     <span style="color: green"> <i>Your Mobile No is {{acnolen}} digit long </i></span>
                                                         </ng-template> -->

                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button class="btn can" (click)=open_list()>{{ translation.t('adminUserManagement', 'cancel') }}</button>
                                            <button class="btn search" (click)="search()">{{ translation.t('adminUserManagement', 'search') }}</button>
                                        </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <!-- <button mat-button mat-raised-button class="btn btn-success"
                                                 matStepperNext>Next</button> -->
                                        </div>
                                    </div>

                                </mat-step>
                                <br>
                                <br>
                                <br>
                                <mat-step [stepControl]="second" completed="false">
                                    <ng-template matStepLabel>
                                        <span matTooltip="{{ translation.t('adminUserManagement', 'identity') }}" class="step-label-tooltip">{{ translation.t('adminUserManagement', 'identity') }}</span>
                                    </ng-template>
                                    <br>
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                {{ translation.t('adminUserManagement', 'personInfo') }}
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row align-items-center mb-3">
                                        <div class="col-12 col-sm-4 text-start mb-2 mb-sm-0 fw-semibold fs-6">
                                            {{ translation.t('adminUserManagement', 'personId') }} <span class="text-danger">*</span>
                                        </div>
                                        <div class="col-12 col-sm-7">
                                            <input type="text" class="form-control" placeholder="{{ translation.t('adminUserManagement', 'systemAssigned') }}"
                                                [(ngModel)]="joiningObj['le_id']" disabled />
                                        </div>
                                    </div>

                                    <div class="row align-items-center mb-3">
                                        <div class="col-12 col-sm-4 text-start mb-2 mb-sm-0 fw-semibold fs-6">
                                            {{ translation.t('adminUserManagement', 'personName') }} <span class="text-danger">*</span>
                                        </div>
                                        <div class="col-12 col-sm-7">
                                            <input type="text" class="form-control" *ngIf="disable_flag == true"
                                                [(ngModel)]="joiningObj['emp_name']" disabled />
                                            <input type="text" class="form-control" *ngIf="disable_flag == false"
                                                [(ngModel)]="joiningObj['emp_name']" />

                                            <span class="text-danger" *ngIf="validSecond && !joiningObj['emp_name']">
                                                {{ translation.t('adminUserManagement', 'personNameRequired') }}
                                            </span>

                                        </div>
                                    </div>


                                    <div class="row align-items-center mb-3">
                                        <div class="col-12 col-sm-4 text-start mb-2 mb-sm-0 fw-semibold fs-6">
                                            {{ translation.t('adminUserManagement', 'email') }} <span class="text-danger">*</span>
                                        </div>
                                        <div class="col-12 col-sm-7">
                                            <input type="email" class="form-control" *ngIf="disable_flag"
                                                [(ngModel)]="joiningObj['emp_email']" disabled />
                                            <input type="email" class="form-control" *ngIf="!disable_flag"
                                                [(ngModel)]="joiningObj['emp_email']"
                                                (ngModelChange)="checkEmail(ngInput.value)" #ngInput />

                                            <ng-container *ngIf="validSecond && !joiningObj['emp_email']">
                                                <span class="text-danger">{{ translation.t('adminUserManagement', 'emailRequired') }}</span>
                                            </ng-container>

                                            <ng-container *ngIf="emailTouched && joiningObj['emp_email']">
                                                <ng-container *ngIf="spanAvi == false; else elseTemplate">
                                                    <span class="text-danger"><i>{{ translation.t('adminUserManagement', 'enterValidEmail') }}</i></span>
                                                </ng-container>
                                                <ng-template #elseTemplate>
                                                    <span style="color: green;"><i>{{ translation.t('adminUserManagement', 'validEmail') }}</i></span>
                                                </ng-template>
                                            </ng-container>


                                        </div>
                                    </div>

                                    <div class="row align-items-center mb-3">
                                        <div class="col-12 col-sm-4 text-start mb-2 mb-sm-0 fw-semibold fs-6">
                                            {{ translation.t('adminUserManagement', 'phone') }} <span class="text-danger">*</span>
                                        </div>
                                        <div class="col-12 col-sm-7">
                                            <input type="number" class="form-control" *ngIf="disable_flag"
                                                [(ngModel)]="joiningObj['emp_phone_no']" disabled />
                                            <input type="number" class="form-control" *ngIf="!disable_flag"
                                                [(ngModel)]="joiningObj['emp_phone_no']" />

                                            <span class="text-danger"
                                                *ngIf="validSecond && !joiningObj['emp_phone_no']">
                                                {{ translation.t('adminUserManagement', 'phoneRequired') }}
                                            </span>

                                        </div>
                                    </div>

                                    <div class="row align-items-center mb-3">
                                        <div class="col-12 col-sm-4 text-start mb-2 mb-sm-0 fw-semibold fs-6">
                                            {{ translation.t('adminUserManagement', 'personDob') }} <span class="text-danger">*</span>
                                        </div>
                                        <div class="col-12 col-sm-7">
                                            <input type="date" class="form-control" *ngIf="!dob_blank"
                                                [(ngModel)]="joiningObj['emp_dob']" disabled />
                                            <input required type="date" class="form-control" *ngIf="dob_blank"
                                                [(ngModel)]="joiningObj['emp_dob']" />

                                            <span class="text-danger" *ngIf="validSecond && !joiningObj['emp_dob']">
                                                {{ translation.t('adminUserManagement', 'dobRequired') }}
                                            </span>

                                        </div>
                                    </div>

                                    <br>
                                    <div class="row">
                                        <div class="col-12 col-sm-6 offset-sm-3">
                                            <div class="d-flex justify-content-center gap-2 text-center"
                                                style="flex-wrap: nowrap;">
                                                <button class="btn can" (click)="open_list()"
                                                    style="white-space: nowrap;">
                                                    {{ translation.t('adminUserManagement', 'cancel') }}
                                                </button>

                                                <button class="btn back" matStepperPrevious
                                                    style="white-space: nowrap;">
                                                    {{ translation.t('adminUserManagement', 'back') }}
                                                </button>
                                                <button class="btn next" (click)="next1step()"
                                                    style="white-space: nowrap;">
                                                    {{ translation.t('adminUserManagement', 'next') }}
                                                </button>

                                            </div>
                                        </div>
                                    </div>



                                </mat-step>
                                <br>
                                <br>
                                <br>
                                <mat-step [stepControl]="third" label="Assignment">
                                    <ng-template matStepLabel>
                                        <span matTooltip="{{ translation.t('adminUserManagement', 'assignment') }}" class="step-label-tooltip">{{ translation.t('adminUserManagement', 'assignment') }}</span>
                                    </ng-template>
                                    <br>
                                    <br>
                                    <div class="row align-items-center text-center mb-4">
                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline" />
                                        </div>
                                        <div class="col-12 col-sm-2">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                {{ translation.t('adminUserManagement', 'employeeInfo') }}
                                            </h6>
                                        </div>
                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline" />
                                        </div>
                                    </div>

                                    <div class="row align-items-center mb-4">
                                        <div class="col-12 col-sm-4 col-md-3 text-start mb-2 mb-sm-0">
                                            <h6 class="mb-0" style="margin-left: 2%;">
                                                {{ translation.t('adminUserManagement', 'employeeId') }} <span style="color:red">*</span>:
                                            </h6>
                                        </div>
                                        <div class="col-12 col-sm-8 col-md-6">
                                            <input type="text" class="form-control fixed-width-input"
                                                placeholder="{{ translation.t('adminUserManagement', 'enterEmployeeId') }}" [(ngModel)]="joiningObj['emp_id']" />

                                            <span class="text-danger" *ngIf="valid && !joiningObj['emp_id']">
                                                {{ translation.t('adminUserManagement', 'employeeIdRequired') }}
                                            </span>


                                        </div>
                                    </div>




                                    <div class="row align-items-center text-center mb-4">
                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline">
                                        </div>

                                        <div class="col-12 col-sm-2">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                {{ translation.t('adminUserManagement', 'selectRole') }}
                                            </h6>
                                        </div>

                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>

                                    <!-- <div class="row"> -->

                                    <div class="row align-items-center mb-4">
                                        <div class="col-12 col-sm-4 col-md-3 text-start mb-2 mb-sm-0">
                                            <h6 class="mb-0" style="margin-left: 2%;">
                                                {{ translation.t('adminUserManagement', 'selectRole') }} <span style="color:red">*</span>:
                                            </h6>
                                        </div>
                                        <div class="col-12 col-sm-8 col-md-6">
                                            <ng-select [items]="current_role" bindLabel="role_name" bindValue="role_cd"
                                                [multiple]="true" placeholder="{{ translation.t('adminUserManagement', 'selectRole') }}"
                                                [(ngModel)]="joiningObj['role_cd']">
                                            </ng-select>

                                            <span class="text-danger"
                                                *ngIf="valid && (!joiningObj['role_cd'] || joiningObj['role_cd'].length === 0)">
                                                {{ translation.t('adminUserManagement', 'roleRequired') }}
                                            </span>

                                        </div>
                                    </div>


                                    <div class="row align-items-center text-center mb-4">
                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline">
                                        </div>

                                        <div class="col-12 col-sm-2">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                {{ translation.t('adminUserManagement', 'selectDepartment') }}
                                            </h6>
                                        </div>

                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>


                                    <!-- <div class="row"> -->

                                    <div class="row align-items-center mb-4">
                                        <div class="col-12 col-sm-4 col-md-3 text-start mb-2 mb-sm-0">
                                            <h6 class="mb-0" style="margin-left: 2%;">
                                                {{ translation.t('adminUserManagement', 'selectDepartment') }} <span style="color:red">*</span>:
                                            </h6>
                                        </div>

                                        <div class="col-12 col-sm-8 col-md-6">
                                            <ng-select [items]="allDepartment" bindLabel="department_name"
                                                bindValue="dep_cd" [multiple]="true" placeholder="{{ translation.t('adminUserManagement', 'selectDepartment') }}"
                                                [(ngModel)]="joiningObj['dep_cd']">
                                            </ng-select>

                                            <span class="text-danger"
                                                *ngIf="valid && (!joiningObj['dep_cd'] || joiningObj['dep_cd'].length === 0)">
                                                {{ translation.t('adminUserManagement', 'departmentRequired') }}
                                            </span>

                                        </div>
                                    </div>


                                    <!-- </div> -->
                                    <div class="row align-items-center text-center mb-4">
                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-12 col-sm-2">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                {{ translation.t('adminUserManagement', 'functionalArea') }}
                                            </h6>
                                        </div>
                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>


                                    <div class="row align-items-center mb-4">
                                        <div class="col-12 col-sm-4 col-md-3 text-start mb-2 mb-sm-0">
                                            <h6 class="mb-0" style="margin-left: 2%;">
                                                {{ translation.t('adminUserManagement', 'functionalArea') }} <span style="color:red">*</span>:
                                            </h6>
                                        </div>
                                        <div class="col-12 col-sm-8 col-md-6">
                                            <ng-select [items]="allModule" bindLabel="module_name" bindValue="module_cd"
                                                [multiple]="true" placeholder="{{ translation.t('adminUserManagement', 'functionalArea') }}"
                                                [(ngModel)]="joiningObj['module_cd']">
                                            </ng-select>

                                            <span class="text-danger"
                                                *ngIf="valid && (!joiningObj['module_cd'] || joiningObj['module_cd'].length === 0)">
                                                {{ translation.t('adminUserManagement', 'functionalAreaRequired') }}
                                            </span>

                                        </div>
                                    </div>


                                    <div class="row align-items-center text-center mb-4">
                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-12 col-sm-2">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                {{ translation.t('adminUserManagement', 'selectHierarchy') }}
                                            </h6>
                                        </div>
                                        <div class="col-12 col-sm-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>

                                    <br />

                                    <div class="row align-items-center mb-4">
                                        <div class="col-12 col-sm-4 col-md-3 text-start mb-2 mb-sm-0">
                                            <h6 class="mb-0" style="margin-left: 2%;">
                                                {{ translation.t('adminUserManagement', 'selectHierarchy') }} <span style="color:red">*</span>:
                                            </h6>
                                            <span class="text-danger"
                                                *ngIf="valid && (!Obj['path_desc'] || Obj['path_desc'].length === 0)">
                                                {{ translation.t('adminUserManagement', 'hierarchyRequired') }}
                                            </span>
                                        </div>
                                        <div class="col-12 col-sm-8 col-md-6">
                                            <button class="btn w-30 w-sm-auto"
                                                style="background-color: #636262; color: white;"
                                                (click)="open_activitypopup()">{{ translation.t('adminUserManagement', 'selectHierarchyBtn') }}</button>
                                        </div>
                                    </div>

                                    <div class="row align-items-center mb-4">
                                        <div class="col-12 col-sm-4 col-md-3 text-start mb-2 mb-sm-0">
                                            <h6 class="mb-0" style="margin-left: 2%;">
                                                {{ translation.t('adminUserManagement', 'selectedHierarchyPath') }}
                                            </h6>
                                        </div>
                                        <div class="col-12 col-sm-8 col-md-6 text-start">
                                            {{Obj['path_desc']}}
                                        </div>
                                    </div>



                                    <!-- Set Employee Node -->


                                    <!-- <br>

                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <h6>Employee Primary Assignment </h6>
                                        </div>
                                    </div>
                                    <br>

                                    <br>
                                    <div class="row">
                                        <div class="col-3 text-center">
                                            Functional Area
                                        </div>
                                        <div class="col-2">
                                            <ng-select [items]="allModule" (change)="ChangeModuleOnPrimary(joiningObj['module_cd'])" bindLabel="module_name" bindValue="module_cd" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="joiningObj['module_cd']" [selectableGroupAsModel]="false"
                                                [closeOnSelect]="true" name="field_name">
                                            </ng-select>
                                        </div>
                                        <br>
                                        <div class="col-3 text-center">
                                            Department/Cost Center*
                                        </div>
                                        <div class="col-2">
                                            <ng-select [items]="cost_centerOnPRI" bindLabel="cost_center_desc" bindValue="cost_center_code" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="joiningObj['cost_center']" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                                name="field_name">
                                            </ng-select>
                                        </div>

                                    </div>
                                    <br>
                                    <br>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">

                                            <h6>Employee secondary Assignment </h6>
                                        </div>
                                        <div class="col-11 text-end">
                                            <button class="btn btn-primary" (click)="addRow()"><i class="fa fa-plus"
                                                    aria-hidden="true"></i></button>
                                        </div>

                                    </div>


                                    <br> -->

                                    <!--------------princy------------------------>

                                    <!-- <div *ngFor="let ln of AllCCRow; let i = index;">


                                        <div class="row">
                                            <div class="col-3 text-center">
                                                Functional Area
                                            </div>
                                            <div class="col-2">
                                                <ng-select [items]="allModule" (change)="ChangeModule(ln['module_cd'],i)" bindLabel="module_name" bindValue="module_cd" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="ln['module_cd']" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                                    name="field_name">
                                                </ng-select>

                                            </div>
                                            <div class="col-3 text-center">
                                                Department/Cost Center*
                                            </div>
                                            <div class="col-2">
                                                <ng-select [items]="cost_center" bindLabel="cost_center_desc" bindValue="cost_center_code" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="ln['cost_center']" [selectableGroupAsModel]="false" [closeOnSelect]="true" name="field_name">
                                                </ng-select>
                                            </div>
                                            <div class="col-2">
                                                <button class="btn btn-danger " (click)="deleteRow(i)"><i
                                                        class="fa fa-trash" aria-hidden="true"></i></button>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="row">
                                        <div class="col-12">
                                            <div class="d-flex justify-content-center"
                                                style="gap: 0.5rem; flex-wrap: nowrap;">
                                                <button class="btn can" style="white-space: nowrap;"
                                                    (click)="open_list()">
                                                    Cancel
                                                </button>
                                                <button class="btn back" style="white-space: nowrap;"
                                                    matStepperPrevious>
                                                    Back
                                                </button>

                                                <button class="btn next" style="white-space: nowrap;"
                                                    (click)="assignNext()">
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </div>





                                </mat-step>
                                <br>
                                <br>
                                <br>

                                <mat-step [stepControl]="fourth">
                                    <ng-template matStepLabel>
                                        <span matTooltip="{{ translation.t('adminUserManagement', 'done') }}" matTooltip="{{ translation.t('adminUserManagement', 'done') }}" class="step-label-tooltip">{{ translation.t('adminUserManagement', 'done') }}</span>
                                    </ng-template>
                                    <br>
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                {{ translation.t('adminUserManagement', 'personInfo') }}
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4 text-sm-end text-start fw-semibold fs-6">
                                            <label>{{ translation.t('adminUserManagement', 'personId') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <input class="form-control w-100" [(ngModel)]="joiningObj['le_id']"
                                                placeholder="{{ translation.t('adminUserManagement', 'systemAssigned') }}" disabled>
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4 text-sm-end text-start fw-semibold fs-6">
                                            <label>{{ translation.t('adminUserManagement', 'personName') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <input class="form-control w-100" [(ngModel)]="joiningObj['emp_name']"
                                                disabled>
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4 text-sm-end text-start fw-semibold fs-6">
                                            <label>{{ translation.t('adminUserManagement', 'email') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <input class="form-control w-100" [(ngModel)]="joiningObj['emp_email']"
                                                disabled>
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4 text-sm-end text-start fw-semibold fs-6">
                                            <label>{{ translation.t('adminUserManagement', 'phone') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <input class="form-control w-100" [(ngModel)]="joiningObj['emp_phone_no']"
                                                disabled>
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4 text-sm-end text-start fw-semibold fs-6">
                                            <label>{{ translation.t('adminUserManagement', 'personDob') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <input class="form-control w-100" [(ngModel)]="joiningObj['emp_dob']"
                                                disabled>
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4  text-sm-end text-start fw-semibold fs-6">
                                            <label>{{ translation.t('adminUserManagement', 'employeeId') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6 ">
                                            <input class="form-control w-100" [(ngModel)]="joiningObj['emp_id']"
                                                disabled>
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4  text-sm-end text-start fw-semibold fs-6">
                                            <label>{{ translation.t('adminUserManagement', 'selectedRole') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <ng-select [items]="current_role" bindLabel="role_name" bindValue="role_cd"
                                                [multiple]="true" [(ngModel)]="joiningObj['role_cd']"
                                                [selectableGroup]="true" [selectableGroupAsModel]="false"
                                                [closeOnSelect]="true" name="role" [disabled]="true">
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4 text-sm-end text-start fw-semibold fs-6">
                                            <label>{{ translation.t('adminUserManagement', 'selectedDepartment') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <ng-select [items]="allDepartment" bindLabel="department_name"
                                                bindValue="dep_cd" [multiple]="true" [(ngModel)]="joiningObj['dep_cd']"
                                                [selectableGroup]="true" [selectableGroupAsModel]="false"
                                                [closeOnSelect]="true" name="department" [disabled]="true">
                                            </ng-select>
                                        </div>
                                    </div>

                                    <br>
                                    <!-- <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <h6>Employee Primary Assignment </h6>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Functional Area
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['module_cd']" disabled>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Department/Cost Center
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['cost_center']" disabled>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <h6>Employee secondary Assignment </h6>
                                        </div>
                                    </div>
                                    <br>
                                    <div *ngFor="let ln of AllCCRow; let i = index;">


                                        <div class="row">
                                            <div class="col-3 text-center">
                                                Functional Area
                                            </div>
                                            <div class="col-2">
                                                <ng-select disabled [items]="allModule" (change)="ChangeModule(ln['module_cd'],i)" bindLabel="module_name" bindValue="module_cd" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="ln['module_cd']" [selectableGroupAsModel]="false"
                                                    [closeOnSelect]="true" name="field_name">
                                                </ng-select>

                                            </div>
                                              <div class="col-3 text-center">
                                                Department/Cost Center*
                                            </div>
                                            <div class="col-2">
                                                <ng-select disabled [items]="cost_center" bindLabel="cost_center_desc" bindValue="cost_center_code" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="ln['cost_center']" [selectableGroupAsModel]="false" [closeOnSelect]="true" name="field_name">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div> -->
                                    <div class="row align-items-center my-3">
                                        <div class="col-5">
                                            <hr class="hrline" />
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 style="color: brown; min-height: 20px;">{{ translation.t('adminUserManagement', 'functionalArea') }}:</h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline" />
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4 text-sm-end text-start">
                                            <label class="fw-semibold">{{ translation.t('adminUserManagement', 'functionalArea') }}:</label>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <ng-select [items]="allModule" bindLabel="module_name" bindValue="module_cd"
                                                [multiple]="true" [(ngModel)]="joiningObj['module_cd']"
                                                [selectableGroup]="true" [selectableGroupAsModel]="false"
                                                [closeOnSelect]="false" name="field_name"
                                                (change)="selectedModule(joiningObj['module_cd'])" [disabled]="true">
                                            </ng-select>
                                        </div>
                                    </div>

                                    <!-- <hr class="my-4" /> -->

                                    <div class="row align-items-center my-3">
                                        <div class="col-5">
                                            <hr class="hrline" />
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 style="color: brown; min-height: 20px;">{{ translation.t('adminUserManagement', 'selectHierarchy') }}:
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline" />
                                        </div>
                                    </div>

                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12 col-sm-4 text-sm-end text-start">
                                            <label class="fw-semibold">{{ translation.t('adminUserManagement', 'selectedHierarchyPath') }}</label>
                                        </div>
                                        <div class="col-12 col-sm-6 text-start">
                                            {{ Obj['path_desc'] }}
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <div class="d-flex flex-row flex-nowrap justify-content-center gap-1 ">
                                                <button class="btn can" (click)="open_list()">{{ translation.t('adminUserManagement', 'cancel') }}</button>
                                                <button class="btn back" matStepperPrevious>{{ translation.t('adminUserManagement', 'back') }}</button>
                                                <button class="btn next" (click)="addJoining()">{{ translation.t('adminUserManagement', 'submit') }}</button>
                                            </div>
                                        </div>
                                    </div>


                                    <br>
                                </mat-step>


                            </mat-horizontal-stepper>

                        </div>


                        <div class="tab-pane fade show active" *ngIf="update_flag" id="tab-3">
                            <br>
                            <div class="row">
                                <div class="col-5">
                                    <hr class="hrline">
                                </div>
                                <div class="col-2 text-center">
                                    <h6 id="h" style="color: brown; min-height: 20px;">
                                        {{ translation.t('adminUserManagement', 'employeeInfo') }}:
                                    </h6>
                                </div>
                                <div class="col-5">
                                    <hr class="hrline">
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-3 text-left">
                                    {{ translation.t('adminUserManagement', 'currentlyEmployeeId') }}
                                </div>
                                <div class="col-3">
                                    <input class="form-control" [(ngModel)]="joiningObj['old_emp_id']" disabled>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-3 text-left">
                                    {{ translation.t('adminUserManagement', 'newEmployeeId') }}
                                </div>
                                <div class="col-3">
                                    <input class="form-control" [(ngModel)]="joiningObj['emp_id']">
                                </div>
                            </div>

                            <br>
                            <br>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <button mat-button mat-raised-button class="btn can"
                                        (click)=open_list()>{{ translation.t('adminUserManagement', 'cancel') }}</button>
                                    &nbsp;&nbsp;
                                    <button mat-button mat-raised-button class="btn btn-success"
                                        (click)="updateEmployeeID()">{{ translation.t('common', 'update') }}</button>
                                </div>
                            </div>
                            <br>
                            <!-- <mat-horizontal-stepper [linear]="isLinear" #stepper2>
                                <mat-step [stepControl]="first" label="Assignment">
                                    <br>
                                    <br>
                                </mat-step>
                                <br>
                            </mat-horizontal-stepper>  -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ngx-spinner>Loading....</ngx-spinner>

<app-spinner></app-spinner>





<!-- MODAL -->
<div class="modal" id="myModal1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <!-- <div class="modal-header">
                <h4 class="modal-title">Challan</h4>
                <button type="button" class="close" data-dismiss ="modal">&times;</button>
            </div> -->

            <!--Modal body -->
            <div class="modal-body">

                <br>


                <div class="row">
                    <div class="col-12 text-center">
                        {{ translation.t('adminUserManagement', 'duplicateEmployeeError') }}
                    </div>
                </div>

                <br>
                <div class="row">
                    <div class="col-3 text-end">
                        <h6>{{ translation.t('adminUserManagement', 'employeeId') }}:</h6>
                    </div>
                    <div class="col-5 text-left">
                        <input type="text" class="form-control" placeholder="" [(ngModel)]="modobj['emp_id']" disabled>

                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3 text-end">
                        <h6> {{ translation.t('adminUserManagement', 'employeeName') }}:</h6>
                    </div>
                    <div class="col-5 text-left">
                        <input type="text" class="form-control" placeholder="" [(ngModel)]="modobj['emp_name']"
                            disabled>

                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3 text-end">
                        <h6> {{ translation.t('adminUserManagement', 'email') }}</h6>
                    </div>
                    <div class="col-5 text-left">
                        <input type="text" class="form-control" placeholder="" [(ngModel)]="modobj['emp_email']"
                            disabled>


                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3 text-end">
                        <h6> {{ translation.t('adminUserManagement', 'phone') }}</h6>
                    </div>
                    <div class="col-5 text-left">
                        <input type="text" class="form-control" placeholder="" [(ngModel)]="modobj['emp_phone_no']"
                            disabled>


                    </div>
                </div>
                <br>
                <br>



                <div class="modal-footer">

                    <button type="button" class="btn btn-danger" data-dismiss="modal">{{ translation.t('adminUserManagement', 'cancel') }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal" id="myModal10">
    <div class="modal-dialog modal-lg" style="max-width: 80%;">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title" style="font: bold; ">{{ translation.t('adminUserManagement', 'role') }}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="card">
                    <div style="margin: 2%;">
                        <table class="table table-borederd" style="width: 80%; margin-left: 10%;">
                            <thead>
                                <tr>
                                    <th>{{ translation.t('adminUserManagement', 'srNo') }}</th>
                                    <th>{{ translation.t('adminUserManagement', 'role') }}</th>
                                    <th>{{ translation.t('adminUserManagement', 'actions') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of single_users_role,let i=index">
                                    <td>{{i+1}}</td>
                                    <td>{{item.role_cd}}</td>
                                    <td>
                                        <button class="btn btn-danger"
                                            *ngIf="single_users_role.length==1 && item['role_cd']=='PROP_EMP'"
                                            (click)="delete(item)">{{ translation.t('adminUser', 'delete') }}</button>
                                        <button class="btn btn-danger"
                                            *ngIf="single_users_role.length==1 && item['role_cd']!='PROP_EMP'"
                                            (click)="delete(item)">{{ translation.t('adminUser', 'delete') }}</button>
                                        <button class="btn btn-danger"
                                            *ngIf="single_users_role.length!=1 && item['role_cd']!='PROP_EMP'"
                                            (click)="delete(item)">{{ translation.t('adminUser', 'delete') }}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">{{ translation.t('adminUserManagement', 'close') }}</button>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="modal" id="myModal11">
  <div class="modal-dialog modal-lg" style="max-width: 80%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" style="font-weight: bold;">{{ translation.t('adminUserManagement', 'employeeDetails') }}</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div class="card p-3">

          <!-- User Name Row -->
          <div class="row mt-3 align-items-center">
            <div class="col-12 col-md-4 offset-md-1 mb-1 mb-md-0">
              <h6 class="mb-0">{{ translation.t('adminUserManagement', 'userName') }} :</h6>
            </div>
            <div class="col-12 col-md-5">
              {{ selected['emp_name'] }}
            </div>
          </div>

          <hr>

          <!-- Role Row -->
          <div class="row mt-3 align-items-center">
            <div class="col-12 col-md-4 offset-md-1 mb-1 mb-md-0">
              <h6 class="mb-0">
                {{ translation.t('adminUserManagement', 'selectRole') }} :
                <span style="color: red;">*</span>
              </h6>
            </div>
            <div class="col-12 col-md-5 mb-2 mb-md-0">
              <ng-select 
                [multiple]="false" 
                [placeholder]="translation.t('adminUserManagement', 'selectRole')"
                [items]="current_role"
                bindLabel="role_name" 
                bindValue="role_cd"
                [selectableGroup]="true"
                [selectableGroupAsModel]="false"
                [closeOnSelect]="true"
                name="role_name" 
                [(ngModel)]="selected['role_cd']">
              </ng-select>
            </div>
            <div class="col-12 col-md-2">
              <button class="btn btn-primary w-100" (click)="submit()">
                {{ translation.t('common', 'update') }}
              </button>
            </div>
          </div>

          <!-- Department Row -->
          <div class="row mt-3 align-items-center">
            <div class="col-12 col-md-4 offset-md-1 mb-1 mb-md-0">
              <h6 class="mb-0">
                {{ translation.t('adminUserManagement', 'selectDepartment') }} :
                <span style="color: red;">*</span>
              </h6>
            </div>
            <div class="col-12 col-md-5 mb-2 mb-md-0">
              <ng-select 
                [items]="allDepartment" 
                bindLabel="department_name" 
                bindValue="dep_cd"
                [placeholder]="translation.t('adminUserManagement', 'selectDepartment')"
                [multiple]="true" 
                [(ngModel)]="selected['dep_cd']">
              </ng-select>
            </div>
            <div class="col-12 col-md-2">
              <button class="btn btn-primary w-100" (click)="submit_dep()">
                {{ translation.t('common', 'update') }}
              </button>
            </div>
          </div>

          <!-- Organization Hierarchy Row -->
          <div class="row mt-3 align-items-center">
            <div class="col-12 col-md-4 offset-md-1 mb-1 mb-md-0">
              <h6 class="mb-0">
                {{ translation.t('adminUserManagement', 'organizationHierarchy') }} :
                <span style="color: red;">*</span>
              </h6>
            </div>
            <div class="col-12 col-md-5 mb-2 mb-md-0">
              <ul class="ps-3 mb-0">
                <li *ngFor="let ob of selected['organization']" class="mb-1">
                  {{ ob['leaf_value'] }} &nbsp;
                  <button 
                    class="btn p-0 ms-1" 
                    (click)="deAssignOrg(ob['leaf_cd'])"
                    *ngIf="selected['organization'].length > 1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                      <path d="M9.66675 14.25L9.66675 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round"/>
                      <path d="M13.3333 14.25L13.3333 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round"/>
                      <path d="M3.25 6.91666H19.75V6.91666C19.0522 6.91666 18.7033 6.91666 18.4194 7.00278C17.7802 7.19668 17.28 7.69688 17.0861 8.33609C17 8.61998 17 8.96888 17 9.66666V14.8333C17 16.7189 17 17.6618 16.4142 18.2475C15.8284 18.8333 14.8856 18.8333 13 18.8333H10C8.11438 18.8333 7.17157 18.8333 6.58579 18.2475C6 17.6618 6 16.7189 6 14.8333V9.66666C6 8.96888 6 8.61998 5.91388 8.33609C5.71998 7.69688 5.21977 7.19668 4.58057 7.00278C4.29667 6.91666 3.94778 6.91666 3.25 6.91666V6.91666Z" stroke="#F52525" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M9.72906 3.58971C9.83351 3.49225 10.0637 3.40613 10.3839 3.34471C10.704 3.28329 11.0963 3.25 11.4999 3.25C11.9035 3.25 12.2958 3.28329 12.616 3.34471C12.9362 3.40613 13.1663 3.49225 13.2708 3.58971" stroke="#F52525" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                </li>
              </ul>
            </div>
            <div class="col-12 col-md-2">
              <button class="btn btn-primary w-100" (click)="open_activitypopup1()">
                {{ translation.t('adminUserManagement', 'assign') }}
              </button>
            </div>
          </div>

          <br>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-danger w-100 w-md-auto" data-dismiss="modal">
            {{ translation.t('adminUserManagement', 'close') }}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- <div class="modal" id="myModal11">
    <div class="modal-dialog modal-lg" style="max-width: 80%;">
        <div class="modal-content">

             <div class="modal-header">
                <h4 class="modal-title" style="font: bold; ">{{ translation.t('adminUserManagement', 'employeeDetails') }}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
             <div class="modal-body">
                <div class="card">

                    <div class="row mt-5">
                        <div class="col-3"></div>
                        <div class="col-3  d-flex  align-items-center">
                            <h6>{{ translation.t('adminUserManagement', 'userName') }} : </h6>
                        </div>
                        <div class="col-3">
                            {{selected['emp_name']}}
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <br>
                <div class="row mt-2">
                        <div class="col-3"></div>
                        <div class="col-3  d-flex  align-items-center">
                            <h6 > {{ translation.t('adminUserManagement', 'selectRole') }} : <span style="color: red;">*</span></h6>
                        </div>
                        <div class="col-4">
                            <ng-select [multiple]="false" placeholder="{{ translation.t('adminUserManagement', 'selectRole') }}" [items]="current_role"
                                bindLabel="role_name" bindValue="role_cd" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" aria-placeholder="Select Role" [closeOnSelect]="true"
                                name="role_name" [(ngModel)]="selected['role_cd']">
                            </ng-select>
                        </div>
                        <div class="col-2"><button class="btn btn-primary" (click)="submit()">{{ translation.t('common', 'update') }}</button></div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-3"></div>
                        <div class="col-3 d-flex  align-items-center">
                            <h6 > {{ translation.t('adminUserManagement', 'selectDepartment') }} : <span style="color: red;">*</span></h6>
                        </div>
                        <div class="col-4">
                       <ng-select [items]="allDepartment" bindLabel="department_name" bindValue="dep_cd"
                                placeholder="{{ translation.t('adminUserManagement', 'selectDepartment') }}" [multiple]="true" [(ngModel)]="selected['dep_cd']">
                            </ng-select>
                        </div>
                        <div class="col-2  d-flex  align-items-center"><button class="btn btn-primary" (click)="submit_dep()">{{ translation.t('common', 'update') }}</button></div>
                    </div>
                    
                    <div class="row mt-2">
                        <div class="col-3"></div>
                        <div class="col-3 d-flex  align-items-center">
                            <h6>{{ translation.t('adminUserManagement', 'organizationHierarchy') }}: <span style="color: red;">*</span></h6>
                        </div>
                        <div class="col-4">
                         
                            <ul *ngFor="let ob of selected['organization']">
                                <li>{{ob['leaf_value']}} &nbsp;&nbsp; <button class="btn" (click)="deAssignOrg(ob['leaf_cd'])" *ngIf="selected['organization'].length>1">&nbsp;   <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                                        viewBox="0 0 23 23" fill="none">
                                                        <path d="M9.66675 14.25L9.66675 11.5" stroke="#F52525"
                                                            stroke-width="2" stroke-linecap="round" />
                                                        <path d="M13.3333 14.25L13.3333 11.5" stroke="#F52525"
                                                            stroke-width="2" stroke-linecap="round" />
                                                        <path
                                                            d="M3.25 6.91666H19.75V6.91666C19.0522 6.91666 18.7033 6.91666 18.4194 7.00278C17.7802 7.19668 17.28 7.69688 17.0861 8.33609C17 8.61998 17 8.96888 17 9.66666V14.8333C17 16.7189 17 17.6618 16.4142 18.2475C15.8284 18.8333 14.8856 18.8333 13 18.8333H10C8.11438 18.8333 7.17157 18.8333 6.58579 18.2475C6 17.6618 6 16.7189 6 14.8333V9.66666C6 8.96888 6 8.61998 5.91388 8.33609C5.71998 7.69688 5.21977 7.19668 4.58057 7.00278C4.29667 6.91666 3.94778 6.91666 3.25 6.91666V6.91666Z"
                                                            stroke="#F52525" stroke-width="1.5"
                                                            stroke-linecap="round" />
                                                        <path
                                                            d="M9.72906 3.58971C9.83351 3.49225 10.0637 3.40613 10.3839 3.34471C10.704 3.28329 11.0963 3.25 11.4999 3.25C11.9035 3.25 12.2958 3.28329 12.616 3.34471C12.9362 3.40613 13.1663 3.49225 13.2708 3.58971"
                                                            stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                                                    </svg>&nbsp;</button></li>
                            </ul>
                        </div>
                        <div class="col-2 d-flex  align-items-center"><button class="btn btn-primary px-3" (click)="open_activitypopup1()"> {{ translation.t('adminUserManagement', 'assign') }}</button>
                           
                            </div>
                    </div> 

                    <br>

              
                </div>


                 <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">{{ translation.t('adminUserManagement', 'close') }}</button>
                </div>

            </div>

        </div>
    </div>
</div> -->

<div class="modal" id="myModal12">
    <div class="modal-dialog modal-lg" style="max-width: 80%;">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title" style="font: bold; ">{{ translation.t('adminUserManagement', 'department') }}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->

            <div class="modal-body">
                <div class="card">
                    <div class="row mt-4">
                        <div class="col-3"></div>
                        <div class="col-3">
                            <h6 style="margin-left: 2%;">{{ translation.t('adminUserManagement', 'userName') }} : </h6>
                        </div>
                        <div class="col-3">
                            {{selected['emp_name']}}
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <br>

                    <div class="row">
                        <div class="col-3"></div>
                        <div class="col-3">
                            <h6 style="margin-left: 2%;">{{ translation.t('adminUserManagement', 'selectDepartment') }} : <span style="color: red;">*</span></h6>
                        </div>
                        <div class="col-3">
                            <ng-select [items]="allDepartment" bindLabel="department_name" bindValue="dep_cd"
                                placeholder="{{ translation.t('adminUserManagement', 'selectDepartment') }}" [multiple]="true" [(ngModel)]="selected['dep_cd']">
                            </ng-select>


                        </div>
                        <div class="col-3"></div>
                    </div>
                    <br>
                    <br>
                    <div class="row">
                        <div class="col-12 text-center">
                            <button class="btn btn-primary" (click)="submit_dep()">{{ translation.t('adminUserManagement', 'submit') }}</button>
                        </div>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">{{ translation.t('adminUserManagement', 'close') }}</button>
                </div>

            </div>

        </div>
    </div>
</div>
















<div class="modal" id="ACTHIER">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title">{{ translation.t('adminUserManagement', 'selectHierarchyBtn') }}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <div class="row" *ngFor="let item of planing_arrproj,let i =index">
                    <div class="col-3"></div>
                    <div class="col-3" *ngIf="i==0">
                        <h6 style="margin-left: 2%;">{{ translation.t('adminUserManagement', 'select') }} <span style="color: red;"> *</span></h6>
                    </div>
                    <div class="col-3" *ngIf="i!=0"></div>
                    <div class="col-1">

                        <span *ngIf="item['level']"> {{ translation.t('adminUserManagement', 'level') }} </span>{{item['level']}}
                    </div>
                    <div class="col-3">
                        <ng-select [items]="item['existing_heirarchy_nodes']" bindLabel="desc" bindValue="node_cd"
                            [multiple]="false" placeholder="{{ translation.t('adminUserManagement', 'selectHierarchyBtn') }}" [(ngModel)]="item['hierarchy_type']"
                            [selectableGroup]="true" (change)="setHierarchyNodeitem(item,i)"
                            [selectableGroupAsModel]="true" [closeOnSelect]="true">
                        </ng-select>

                    </div>
                    <div class="col-2" *ngIf="i==planing_arrproj.length-1">
                        <button (click)="down(item,i)" class="btn btn-primary"><i class="fa fa-arrow-down"
                                aria-hidden="true"></i></button> &nbsp;&nbsp;
                        <button (click)="remove(item,i)" class="btn btn-danger">
                            <i class="fa fa-arrow-up" aria-hidden="true"></i></button>
                    </div>
                    <div class="col-3"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3"></div>
                    <div class="col-3 ">
                        <h6 style="margin-left: 2%;"> <span style="color: red;">*</span> {{ translation.t('adminUserManagement', 'currentHierarchyPath') }}
                        </h6>
                    </div>
                    <div class="col-6">
                        {{Obj['path_desc']}}
                    </div>

                </div>
                <br>
                <h5>{{ translation.t('adminUserManagement', 'instructions') }}</h5>
                <ul>
                    <li>{{ translation.t('adminUserManagement', 'instruction1') }}</li>
                    <li>{{ translation.t('adminUserManagement', 'instruction2') }}</li>
                    <li>{{ translation.t('adminUserManagement', 'instruction3') }}</li>
                    <li>{{ translation.t('adminUserManagement', 'instruction4') }}   <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17"  viewBox="0 0 17 17" fill="none"> <g clip-path="url(#clip0_582_5824)"> <path  d="M7.83325 3.16665H3.16659C2.81296 3.16665 2.47382 3.30713 2.22378 3.55718C1.97373 3.80723 1.83325 4.14637 1.83325 4.49999V13.8333C1.83325 14.1869 1.97373 14.5261 2.22378 14.7761C2.47382 15.0262 2.81296 15.1667 3.16659 15.1667H12.4999C12.8535 15.1667 13.1927 15.0262 13.4427 14.7761C13.6928 14.5261 13.8333 14.1869 13.8333 13.8333V9.16665M12.8333 2.16665C13.0985 1.90144 13.4582 1.75244 13.8333 1.75244C14.2083 1.75244 14.568 1.90144 14.8333 2.16665C15.0985 2.43187 15.2475 2.79158 15.2475 3.16665C15.2475 3.54173 15.0985 3.90144 14.8333 4.16665L8.49992 10.5L5.83325 11.1667L6.49992 8.49999L12.8333 2.16665Z" stroke="#1E1E1E" stroke-width="1.6"  stroke-linecap="round" stroke-linejoin="round" />  </g>  <defs> <clipPath id="clip0_582_5824">  <rect width="16" height="16" fill="white"  transform="translate(0.5 0.5)" />    </clipPath>     </defs>  </svg></li>
                     
                </ul>

                <div class="modal-footer">
                    <button class="btn btn-primary" (click)="submit_act()">{{ translation.t('adminUserManagement', 'submit') }}</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal">{{ translation.t('adminUserManagement', 'close') }}</button>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal" id="REASSIGNORG">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title">{{ translation.t('adminUserManagement', 'selectHierarchyBtn') }}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <div class="row" *ngFor="let item of planing_arrproj,let i =index">
                    <div class="col-3"></div>
                    <div class="col-3" *ngIf="i==0">
                        <h6 style="margin-left: 2%;">{{ translation.t('adminUserManagement', 'select') }} <span style="color: red;"> *</span></h6>
                    </div>
                    <div class="col-3" *ngIf="i!=0"></div>
                    <div class="col-1">

                        <span *ngIf="item['level']"> {{ translation.t('adminUserManagement', 'level') }} </span>{{item['level']}}
                    </div>
                    <div class="col-3">
                        <ng-select [items]="item['existing_heirarchy_nodes']" bindLabel="desc" bindValue="node_cd"
                            [multiple]="false" placeholder="{{ translation.t('adminUserManagement', 'selectHierarchyBtn') }}" [(ngModel)]="item['hierarchy_type']"
                            [selectableGroup]="true" (change)="setHierarchyNodeitem(item,i)"
                            [selectableGroupAsModel]="true" [closeOnSelect]="true">
                        </ng-select>

                    </div>
                    <div class="col-2" *ngIf="i==planing_arrproj.length-1">
                        <button (click)="down(item,i)" class="btn btn-primary"><i class="fa fa-arrow-down"
                                aria-hidden="true"></i></button> &nbsp;&nbsp;
                        <button (click)="remove(item,i)" class="btn btn-danger">
                            <i class="fa fa-arrow-up" aria-hidden="true"></i></button>
                    </div>
                    <div class="col-3"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3"></div>
                    <div class="col-3 ">
                        <h6 style="margin-left: 2%;"> <span style="color: red;">*</span> {{ translation.t('adminUserManagement', 'currentHierarchyPath') }}
                        </h6>
                    </div>
                    <div class="col-6">
                        {{Obj['path_desc']}}
                    </div>

                </div>
                <br>
                <h5>{{ translation.t('adminUserManagement', 'instructions') }}</h5>
                <ul>
                    <li>{{ translation.t('adminUserManagement', 'instruction1') }}</li>
                    <li>{{ translation.t('adminUserManagement', 'instruction2') }}</li>
                    <li>{{ translation.t('adminUserManagement', 'instruction3') }}</li>
                    <li>{{ translation.t('adminUserManagement', 'instruction5') }}</li>
                     
                </ul>

                <div class="modal-footer">
                    <button class="btn btn-primary" (click)="submit_Org()">{{ translation.t('adminUserManagement', 'submit') }}</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal">{{ translation.t('adminUserManagement', 'close') }}</button>
                </div>

            </div>
        </div>
    </div>
</div>